<template>
    <hts-router-drawer
        :title="$t('labels.quoteRequestDetail')"
        :size="80"
        :rules="dataRule"
        is-close
        :page-tabs="pageTabs?.quote || []"
        @loaded="getData">
        <div :style="{ minWidth: minWidthScroll }">
            <div class="font-bold ml-3 my-3 flex space-x-1 items-center">
                <span>
                    {{ $t('labels.status') }}:
                </span>
                <status-component
                    size="large"
                    module="quoteRequest"
                    :status="dataEditQuotRequest.status" />
            </div>
            <hts-card :title="$t('labels.customer')">
                <div class="grid gap-x-2 grid-cols-4">
                    <hts-select-cooperator
                        v-model="dataEditQuotRequest.customer"
                        v-model:name="dataEditQuotRequest.customerName"
                        :label="$t('labels.customer')"
                        type-cooperator="CUSTOMER"
                        :creatable="true"
                        readonly
                        prop="customer"
                        name-select="customer" />
                    <hts-select-cooperator-contact
                        v-model="dataEditQuotRequest.contact"
                        v-model:name="dataEditQuotRequest.contactName"
                        readonly
                        :cooperator-id="dataEditQuotRequest.customer"
                        :label="$t('labels.contact')"
                        required
                        prop="contact"
                        name-select="contact"
                        @change="selectContact" />
                    <hts-form-input
                        v-model="dataContact.email"
                        :label="$t('labels.email')"
                        readonly
                        required />
                    <hts-form-input
                        v-model="dataContact.phone"
                        :label="$t('labels.phone')"
                        readonly
                        required />
                </div>
            </hts-card>
            <hts-card :title="$t('labels.shippingInformation')">
                <div class="grid gap-x-2 grid-cols-2">
                    <hts-select-cooperator-business-opportunity
                        v-model="dataEditQuotRequest.businessOpportunity"
                        v-model:name="dataEditQuotRequest.businessOpportunityName"
                        :label="$t('labels.businessOpportunity')"
                        :creatable="true"
                        readonly
                        :cooperator-id="dataEditQuotRequest.customer"
                        required
                        prop="businessOpportunity"
                        name-select="businessOpportunity"
                        key-label="nameCustom1"
                        key-sub-label="nameCustom2"
                        @change="selectCooperatorBusinessOpportunity" />
                    <hts-select-commodity-opportunity
                        v-model="dataEditQuotRequest.commodity"
                        v-model:name="dataEditQuotRequest.commodityName"
                        :label="$t('labels.commodity')"
                        :creatable="true"
                        readonly
                        :cooperator-id="dataEditQuotRequest.customer"
                        :opportunity-id="dataEditQuotRequest.businessOpportunity"
                        required
                        prop="commodityBusinessOpportunity"
                        name-select="commodityBusinessOpportunity" />
                </div>
                <hts-form-input
                    v-model="dataEditQuotRequest.workflowName"
                    :label="$t('labels.workflow')"
                    readonly
                    required />
                <ul
                    v-if="dataEditQuotRequest.positions && dataEditQuotRequest.positions.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in dataEditQuotRequest.positions"
                        :key="index"
                        data-content=" "
                        class="pl-10 step w-full">
                        <div class="flex items-center justify-center w-full">
                            <span class="w-52 flex justify-start">
                                {{ item.nodeTypeName }}
                            </span>
                            <div class="flex items-center w-full gap-5">
                                <hts-form-input
                                    v-model="item.fullNameNode"
                                    class="w-full"
                                    readonly />

                                <hts-form-button
                                    icon-name="hi-eye-icon"
                                    size="small"
                                    class="w-96"
                                    color="info"
                                    @click="() => openWorkflowPosition(item)">
                                    {{ $t('labels.viewTaskInfo') }}
                                </hts-form-button>
                            </div>
                        </div>
                    </li>
                </ul>

                <hts-form-button
                    v-if="dataEditQuotRequest.positions && dataEditQuotRequest.positions.length"
                    icon-name="hi-plus-circle-icon"
                    class="text-right mt-5 w-48"
                    color="info"
                    :btn-outline="false"
                    type="button"
                    @click="handleFindRoutingConnection">
                    Xem trái tuyến
                </hts-form-button>

                <div>
                    <div v-if="dataEditQuotRequest.transportation === 'CONTAINER'">
                        <hts-form-input
                            v-model="dataEditQuotRequest.contName"
                            :label="$t('labels.cont')"
                            readonly />
                        <span>
                            {{ $t('labels.requestSpecial') }}
                        </span>
                        <div class="flex">
                            <hts-form-checkbox
                                v-if="dataEditQuotRequest.contCategory === 20"
                                v-model="dataEditQuotRequest.mergeContainer"
                                color="secondary"
                                readonly
                                :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                            <hts-form-checkbox
                                v-model="dataEditQuotRequest.headContainer"
                                color="secondary"
                                readonly
                                :items="[{ label: $t('labels.headContainer'), value: false }]" />
                        </div>
                    </div>
                    <div v-else-if="dataEditQuotRequest.transportation === 'NON_CONTAINER'">
                        <hts-form-input
                            v-model="dataEditQuotRequest.vehicleCategoryName"
                            :label="$t('labels.vehicleType')"
                            readonly
                            required />
                    </div>
                    <hts-form-input
                        v-model="dataEditQuotRequest.productivity"
                        :label="$t('labels.productivityByMount')"
                        type="number"
                        readonly
                        prop="productivity"
                        name="productivity">
                        <template #suffix>
                            <span>
                                {{ dataEditQuotRequest.transportation ? (dataEditQuotRequest.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                            </span>
                        </template>
                    </hts-form-input>
                    <hts-form-input
                        v-model="dataEditQuotRequest.weightCommodity"
                        :label="$t('labels.weightCommodityByKG1')"
                        type="number"
                        readonly
                        prop="weightCommodityByKG"
                        name="weightCommodityByKG1">
                        <template #suffix>
                            <span>
                                {{ dataEditQuotRequest.transportation ? (dataEditQuotRequest.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                            </span>
                        </template>
                    </hts-form-input>
                    <hts-form-textarea
                        v-model="dataEditQuotRequest.request"
                        :label="$t('labels.requestOther')"
                        readonly />
                </div>
            </hts-card>
        </div>
        <workflow-position ref="workflowPosition" />
        <routing-connection
            ref="routingConnection"
            :edit="false" />
    </hts-router-drawer>
</template>

<script lang="ts" setup>
import RoutingConnection from '../-components/routing-connection.vue'
import WorkflowPosition from '../-components/workflow-position.vue'
import { $api } from '#imports'
import StatusComponent from '@/pages/trucker-[id]/statistics/-components/status.vue'
import pageTabs from '~/data/page-tabs/trucker.json'
import { IWorkflowPosition } from '~/pages/admincp/workflow/ignore/imports/form'
import { IQuoteRequest } from '~/pages/trucker-[id]/quote/quote-request/-components/ignore/imports/form'

import screen from '~/components/utils/screen'
const { $disableReactive } = useNuxtApp()
const route = useRoute()
const quoteRequestId = computed(() => useRoute().params.idquoterequest)
const store = $store()
const routingConnection = ref()
const routingConnectionsData = ref<{ [key: string]: any }[][]>([])

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const emits = defineEmits(['refreshTables'])

const dataContact = ref<{ [key: string]: any }>({})
const selectContact = (item: { [key: string]: any }) => {
  dataContact.value = Array.isArray(item) && item.length && item[0]
}

const loadingSelectCooperator = ref(false)

const dataCooperatorBusinessOpportunity = ref<{ [key: string]: any }>({})
const selectCooperatorBusinessOpportunity = async (item: { [key: string]: any }) => {
  loadingSelectCooperator.value = true
  dataCooperatorBusinessOpportunity.value = Array.isArray(item) && item.length && item[0]
  await setFormData()
}

const setFormData = async () => {
  dataEditQuotRequest.value.productivity = dataCooperatorBusinessOpportunity.value.productivity || null
  dataEditQuotRequest.value.weightCommodity = dataCooperatorBusinessOpportunity.value.weightCommodity || null
  dataEditQuotRequest.value.transportation = dataCooperatorBusinessOpportunity.value.transportation || ''
  if (dataEditQuotRequest.value.transportation && dataEditQuotRequest.value.transportation === 'CONTAINER') {
    dataCooperatorBusinessOpportunity.value.contName = listLabelCont[dataCooperatorBusinessOpportunity.value.contCategory] ?? ''
  } else if (dataEditQuotRequest.value.transportation && dataEditQuotRequest.value.transportation === 'NON_CONTAINER') {
    dataCooperatorBusinessOpportunity.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryDetail?.name ?? ''
  }
  dataEditQuotRequest.value.workflow = dataCooperatorBusinessOpportunity.value.workflow
  dataEditQuotRequest.value.contCategory = dataCooperatorBusinessOpportunity.value.contCategory
  dataEditQuotRequest.value.vehicleCategory = dataCooperatorBusinessOpportunity.value.vehicleCategory
  dataEditQuotRequest.value.headContainer = false
  dataEditQuotRequest.value.mergeContainer = false
  dataEditQuotRequest.value.workflowName = dataCooperatorBusinessOpportunity.value.workflowName
  dataEditQuotRequest.value.positions = dataCooperatorBusinessOpportunity.value.positions || []
  dataEditQuotRequest.value.contName = dataCooperatorBusinessOpportunity.value.contName || []
  dataEditQuotRequest.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryName || ''
  await setDataPosition()
}

const setDataPosition = async () => {
  try {
    const api = $url.quote.quoteRequest.viewTimeComplete
    if (dataEditQuotRequest.value.businessOpportunity) {
      const data: any = await $api(api, { uriParams: { IDBUSINESSOPPORTUNITY: dataEditQuotRequest.value.businessOpportunity } })
      const resData = data?.data?.value
      if (resData && resData.success) {
        dataEditQuotRequest.value.positions = resData.data
        loadingSelectCooperator.value = false
      }
    }
    loadingSelectCooperator.value = false
  } catch (e) {
    loadingSelectCooperator.value = false
  }
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const dataEditQuotRequest = ref<IQuoteRequest>({
  customer: '',
  customerName: '',
  commodity: '',
  commodityName: '',
  contact: '',
  businessOpportunity: '',
  workflow: '',
  workflowData: [],
  productivity: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: null
    }
  ],
  request: '',
  requestSpecial: '',
  contactName: '',
  mergeContainer: false,
  headContainer: false,
  transportation: '',
  businessOpportunityName: '',
  contCategory: null,
  vehicleCategory: '',
  status: -1,
  routingConnections: undefined,
  connectingPositions: undefined
})

onBeforeMount(() => {
  route.meta.pageTabs = pageTabs?.quote || []
})
const getData = () => {
  const api = $url.quote.quoteRequest.getDetail
  $api(api, { uriParams: { ID: quoteRequestId.value } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataEditQuotRequest.value, { ...resData.data })
        Object.assign(dataContact.value, { ...resData.data?.contactDetail })
        if (dataEditQuotRequest.value.contCategory) {
          dataEditQuotRequest.value.contName = listLabelCont[dataEditQuotRequest.value.contCategory] ?? ''
        }
        if (dataEditQuotRequest.value.routingConnections) {
          routingConnectionsData.value = $lodash.cloneDeep(resData.data.routingConnections)
          dataEditQuotRequest.value.routingConnections = dataEditQuotRequest.value.routingConnections.map((item: any) => {
            const pluckIdData = $lodash.map(item, 'node')
            const nodeIds = $lodash.join(pluckIdData, '-')
            return nodeIds
          })
        }
      }
    })
    .catch(() => {})
}

const workflowPosition = ref()
const openWorkflowPosition = (position: IWorkflowPosition) => {
  if (workflowPosition.value) {
    workflowPosition.value.open($disableReactive(position), dataEditQuotRequest.value, true)
  }
}

const defineRule: { [key: string]: any } = {}

const configCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)

const configVehicle: { [key: string]: any } = computed(() => {
  return store.data.getVehicleCategories
})

const dataRule = computed(() => {
  const result: { [key: string]: any } = { ...{}, ...defineRule }
  if (dataEditQuotRequest.value.transportation === 'CONTAINER' && dataEditQuotRequest.value.contCategory) {
    if (configCont.value && configCont.value[dataEditQuotRequest.value.contCategory] && configCont.value[dataEditQuotRequest.value.contCategory].weightCargo) {
      result.weightCommodityByKG = 'required|max_value:' + configCont.value[dataEditQuotRequest.value.contCategory].weightCargo
    }
  } else if (dataEditQuotRequest.value.transportation === 'NON_CONTAINER' && dataEditQuotRequest.value.vehicleCategory && configVehicle.value) {
    const findVehicleCategory = configVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
      return findVehicleCategory._id === dataEditQuotRequest.value.vehicleCategory
    })
    if (findVehicleCategory) {
      result.weightCommodityByKG = `required|min_value:${findVehicleCategory.from || 0}|max_value:${findVehicleCategory.to || '999999999999999'}`
    }
  }
  return result
})

const handleFindRoutingConnection = () => {
  if (routingConnection?.value) {
    routingConnection.value.open(
      dataEditQuotRequest.value.positions || [],
      dataEditQuotRequest.value.routingConnections,
      dataEditQuotRequest.value.connectingPositions || []
    )
  }
}
</script>

<style scoped></style>
